/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Guide
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 07Sep2022 craig File created.
 \******************************************************************************/
import React from "react";
import * as Yup from 'yup';
import {Formik, ErrorMessage} from 'formik';
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {getDataPost} from "../../../../models/data/Data";

export const Guide: React.FC = () => {
    const schema = Yup.object().shape({
        subject: Yup.string().required(),
        message: Yup.string().required(),
    });

    const buildForm = () => {
        return (
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const data = `${encodeURIComponent("subject")}=${encodeURIComponent(values.subject)}&${encodeURIComponent("message")}=${encodeURIComponent(values.message)}`
                    const loginURL = process.env.REACT_APP_API_URL + "/api/insertnewguide";
                    getDataPost(loginURL, data).then(response => {
                        //console.log(response);
                    })
                }}
                initialValues={{
                    subject: '',
                    message: '',
                }}
                validateOnChange={false}
                validateOnBlur={false}>
                {({
                      handleSubmit,
                      handleChange,
                      resetForm,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                      isSubmitting,
                  }) => (
                    <Form className="form-layout" onSubmit={handleSubmit} noValidate={true}>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="formBasicEmail">
                                <Form.Label>Subject *</Form.Label>
                                <Form.Control required
                                              name={"subject"}
                                              className="text-mid-width"
                                              type="text"
                                              placeholder="subject"
                                              isValid={touched.subject && !errors.subject}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter your subject.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a subject
                                </Form.Control.Feedback>
                                <ErrorMessage name={"subject"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="formBasicPassword">
                                <Form.Label>Message *</Form.Label>
                                <Form.Control required
                                              name={"message"}
                                              as="textarea"
                                              className="text-mid-width"
                                              placeholder="Message"
                                              rows={5}
                                              isValid={touched.message && !errors.message}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter the message.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please enter a message
                                </Form.Control.Feedback>
                                <ErrorMessage name={"message"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Button variant="primary" className="btn-submit" type="submit">
                            Submit
                        </Button>
                    </Form>
                )}
            </Formik>
        )

    }
    return (
        <Container className="form-container" fluid>
            <Row>
                <Col className="page-title">
                    <h1 className="page-title">Gold Standard Guide</h1>
                </Col>
            </Row>
            {buildForm()}
        </Container>
    )
}